import { DataGridPro } from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";
import { useCompanyId } from "../../core";
import { SmallLoading } from "../../ui/Loading";
import { Button, Grid, Header } from "semantic-ui-react";
import {
  getAllSpvs,
  getWorkflowLogs,
  triggerActualsSync,
} from "./amProjectSync.client";
import { useMessages } from "../../ui/MessagesProvider";
import { GridToolbar } from "@mui/x-data-grid";
import { DateRange } from "../../lineitems-store/DateRange";
import { addMonths } from "../../ps-models";
import { WorkflowLogsEntityCrud } from "./WorkflowLogsEntityCrud";

export function SyncSpvs() {
  const [spvs, setSpvs] = useState<string[]>([]);
  const [executionId, setExecutionId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const companyId = useCompanyId();
  const [selected, setSelected] = useState<string[]>([]);
  const { info, error } = useMessages();
  const [startDate, setStartDate] = useState<Date>(
    addMonths(new Date("2023-01-01"), -3)
  );
  const [endDate, setEndDate] = useState<Date>(new Date());

  useEffect(() => {
    getAllSpvs(companyId).then((res) => {
      setSpvs(res!);
      setLoading(false);
    });
  }, []);


  //Projects map to Table for MUIX GRid
  const rows = spvs.map((spv: any) => {
    return {
      id: spv.SPV,
      name: spv.name
    };
  });

  const columns = Object.keys(rows[0] || {}).map((key) => {
    return {
      field: key,
      headerName: key,
      width: 350,
    };
  });

  const handleImportSpvs = () => {
    if (selected.length == 0) {
      error("Please select at least one SPV.");
      return;
    }
    setLoading(true);
    triggerActualsSync(companyId, selected, "SPV", {
      dateFrom: startDate.getTime(),
      dateTo: endDate.getTime(),
    })
      .then((res) => {
        info("SPV Sync Started, please follow logs to see progress.");
        setExecutionId(res.executionId);
        setLoading(false);
      })
      .catch((e) => {
        error(`Error syncing SPVs ${e.message}`);
        setLoading(false);
      });
  };

  return (
    <div>
      <div>
        <Header floated="left" as="h3">
          Sync SPVs
        </Header>
        <div style={{ clear: "both" }}></div>
        <div>
          <DateRange
            initialStartDate={startDate}
            initialEndDate={endDate}
            onSelect={(start, end) => {
              setStartDate(start);
              setEndDate(end);
            }}
          />
          <Button content={"SPVs Sync"} onClick={handleImportSpvs} />
        </div>
      </div>

      <div style={{ clear: "both" }}></div>

      {loading && <SmallLoading message="loading projects" />}

      <div style={{ width: "100%", marginTop: "20px" }}>
        <DataGridPro
          density={"compact"}
          rows={rows}
          columns={columns}
          pagination={true}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 15,
              },
            },
          }}
          autoHeight
          columnBuffer={2}
          columnThreshold={2}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          checkboxSelection
          disableRowSelectionOnClick
          onRowSelectionModelChange={(selection) => {
            console.log(selection);
            setSelected(selection as string[]);
          }}
        />
      </div>
      <div style={{ margin: "20px 0px" }}>
        <WorkflowLogsEntityCrud type="SPV" executionId={executionId} />
      </div>
    </div>
  );
}
